import { type ReactNode } from 'react';

interface IntelligenceItemProps {
	icon: ReactNode;
	label: string;
	count: number;
	onClick?: () => void;
	className?: string;
}

export const IntelligenceItem = ({
	icon,
	label,
	count,
	onClick,
	className = '',
}: IntelligenceItemProps) => {
	const isClickable = !!onClick;

	const content = (
		<>
			<div className="flex flex-row items-center gap-2 w-full">
				<div className="flex-shrink-0 text-[#62748E]">{icon}</div>
				<span className="flex-1 font-['Inter'] font-normal text-sm leading-5 text-[#62748E]">{label}</span>
			</div>
			<span className="w-full font-['Inter'] font-normal text-sm leading-5 text-[#006FEE]">
				{count} {label === 'Breach History' ? 'events' : label === 'Dark Web Chatter' ? 'findings' : label === 'Compliance' ? 'certifications' : 'articles'}
			</span>
		</>
	);

	if (isClickable) {
		return (
			<button
				type="button"
				onClick={onClick}
				className={`flex flex-col items-flex-start p-3 gap-2 bg-[#F8FAFC] rounded-lg hover:bg-gray-100 transition-colors text-left w-full ${className}`}
				aria-label={`${label}: ${count}`}
			>
				{content}
			</button>
		);
	}

	return (
		<div
			className={`flex flex-col items-flex-start p-3 gap-2 bg-[#F8FAFC] rounded-lg ${className}`}
			role="group"
			aria-label={`${label}: ${count}`}
		>
			{content}
		</div>
	);
};
